export const HELP_URL = 'https://help.cycle.app/';
export const FAQ_URL = 'https://intercom.help/cycle-help/en';
export const CHANGELOG_URL = 'https://cycle-changelog.super.site/';
export const FEEDBACK_URL = 'https://tally.so/r/npex4Z';
export const SLACK_URL = 'https://join.slack.com/t/cycle-family/shared_invite/zt-yaoshls1-EcvtG2BZ4lqyXsSprnN2rQ';
export const TWITTER_URL = 'https://twitter.com/CycleProduct';
export const REQUEST_ACCESS = 'https://tally.so/r/wgDla1';
